import { SuspensePageBoundary } from "@-/dev.improve.haniverse.components.ui.suspense-page";
import { MorphemeInfoPanelLoadingView } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content";
import { GraphemeInfoView } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._views.grapheme.info";
import type { ReactNode } from "react";

/**
 * A grapheme's reference panel as a standalone card surface. Its sections load inside their own
 * boundary, so a slow reference read never holds up the card that hosts it; `children` render
 * after the resolved content (a readiness marker, say).
 */
export function GraphemeInfoFlashcardSurface({
  children,
  grapheme,
}: {
  children?: ReactNode;
  grapheme: string;
}) {
  return (
    <SuspensePageBoundary
      fallback={<MorphemeInfoPanelLoadingView />}
      location={import.meta.location}
    >
      <GraphemeInfoView grapheme={grapheme} />
      {children}
    </SuspensePageBoundary>
  );
}
